import { Routes as DomRoutes, Route } from 'react-router-dom';
import { ADMIN, BRISTEC_ADMIN, MODERATOR } from '../const/constants';
import { Attendance } from '../features/attendance/Attendance';
import { BankingTotals } from '../features/banking-totals/BankingTotals';
import { Banking } from '../features/banking/Banking';
import { Branches } from '../features/branches/Branches';
import { BristecAdmin } from '../features/bristec/BristecAdmin';
import { CashDeclarations } from '../features/cash-declaration/CashDeclaration';
import { Customers } from '../features/customers/Customers';
import { SingleCustomer } from '../features/customers/SingleCustomer';
import { Departments } from '../features/departments/Departments';
import { EodLogs } from '../features/eod-logs/EodLogs';
import { EodVats } from '../features/eod-vat/EodVat';
import { EndpointNotFound } from '../features/error/EndpointNotFound';
import { InternalServerError } from '../features/error/InternalServerError';
import { PageNotFound } from '../features/error/PageNotFound';
import { GroupProductSales } from '../features/group-totals/GroupProductSales';
import { GroupTotals } from '../features/group-totals/GroupTotals';
import { Groups } from '../features/groups/Groups';
import { Dashboard } from '../features/home/Dashboard';
import { Login } from '../features/login/Login';
import { MissedItems } from '../features/missed-items/MissedItems';
import { NearMisses } from '../features/near-miss/NearMisses';
import { Orders } from '../features/orders/Orders';
import { Accounts } from '../features/organisation-accounts/Accounts';
import { PaidInOut } from '../features/paid-in-out/PaidInOut';
import { PharmacyFirst } from '../features/pharmacy-first/PharmacyFirst';
import { PosMessages } from '../features/pos-messages/PosMessages';
import { Prescriptions } from '../features/prescriptions/Prescriptions';
import { PriceChange } from '../features/price-change/PriceChange';
import { ProductLogs } from '../features/product-logs/ProductLogs';
import { ProductTotals } from '../features/product-totals/ProductTotals';
import { ProductCost } from '../features/products-cost/ProductCost';
import { Products } from '../features/products/Products';
import { SingleProduct } from '../features/products/SingleProduct';
import { Promotions } from '../features/promotions/Promotions';
import { RearDisplay } from '../features/rear-display/RearDisplay';
import { Receipt } from '../features/receipts/Receipt';
import { RxCounts } from '../features/rx-counts/RxCounts';
import { SalesViewer } from '../features/sales-viewer/SalesViewer';
import { SingleStaffMember } from '../features/staff/SingleStaffMember';
import { StaffList } from '../features/staff/StaffList';
import { Suppliers } from '../features/suppliers/Suppliers';
import { Tenders } from '../features/tenders/Tenders';
import { VatRates } from '../features/vat-rates/VatRates';
import { VatReports } from '../features/vat-reports/VatReports';
import { Voids } from '../features/voids/Voids';
import { WeeklyTargets } from '../features/weekly-targets/WeeklyTargets';
import { AdminRoute, PrivateRoute } from './AuthRouteGuards';
import { RouteToHome } from './RouteToDash';

export function Routes() {
	return (
		<DomRoutes>
			<Route path="/" element={<RouteToHome />} />
			<Route path="/:organisation/" element={<RouteToHome />} />
			<Route path="/login" element={<Login />} />
			<Route
				path="/:organisation/dash"
				element={<PrivateRoute element={<Dashboard />} />}
			/>
			<Route
				path="/:organisation/sales/sales-viewer"
				element={<PrivateRoute element={<SalesViewer />} />}
			/>
			<Route
				path="/:organisation/sales/product-totals"
				element={<PrivateRoute element={<ProductTotals />} />}
			/>
			<Route
				path="/:organisation/sales/group-totals"
				element={<PrivateRoute element={<GroupTotals />} />}
			/>
			<Route
				path="/:organisation/sales/tenders"
				element={<PrivateRoute element={<Tenders />} />}
			/>
			<Route
				path="/:organisation/sales/group-totals"
				element={<PrivateRoute element={<GroupTotals />} />}
			/>
			<Route
				path="/:organisation/receipt/:receiptId"
				element={<PrivateRoute element={<Receipt />} />}
			/>
			<Route
				path="/:organisation/maintenance/branches"
				element={<PrivateRoute element={<Branches />} />}
			/>
			<Route
				path="/:organisation/maintenance/promotions"
				element={<PrivateRoute element={<Promotions />} />}
			/>
			<Route
				path="/:organisation/maintenance/vat-reports"
				element={<PrivateRoute element={<VatReports />} />}
			/>
			<Route
				path="/:organisation/maintenance/vat-reports"
				element={<PrivateRoute element={<VatReports />} />}
			/>
			<Route
				path="/:organisation/maintenance/eod-vat"
				element={<PrivateRoute element={<EodVats />} />}
			/>
			<Route
				path="/:organisation/maintenance/departments"
				element={<PrivateRoute element={<Departments />} />}
			/>
			<Route
				path="/:organisation/maintenance/groups"
				element={<PrivateRoute element={<Groups />} />}
			/>
			<Route
				path="/:organisation/maintenance/suppliers"
				element={<PrivateRoute element={<Suppliers />} />}
			/>
			<Route
				path="/:organisation/maintenance/pos-messages"
				element={<PrivateRoute element={<PosMessages />} />}
			/>
			<Route
				path="/:organisation/maintenance/vat-rates"
				element={<PrivateRoute element={<VatRates />} />}
			/>
			<Route
				path="/:organisation/sales/group-totals/:departmentId"
				element={<PrivateRoute element={<GroupProductSales />} />}
			/>
			<Route
				path="/:organisation/stock/products"
				element={<PrivateRoute element={<Products />} />}
			/>
			<Route
				path="/:organisation/stock/products/:skuid"
				element={<PrivateRoute element={<SingleProduct />} />}
			/>
			<Route
				path="/:organisation/stock/price-change"
				element={<PrivateRoute element={<PriceChange />} />}
			/>
			<Route
				path="/:organisation/stock/product-log"
				element={<PrivateRoute element={<ProductLogs />} />}
			/>
			<Route
				path="/:organisation/stock/product-cost"
				element={<PrivateRoute element={<ProductCost />} />}
			/>
			<Route
				path="/:organisation/epos/voids"
				element={<PrivateRoute element={<Voids />} />}
			/>
			<Route
				path="/:organisation/epos/head-office"
				element={<PrivateRoute element={<PageNotFound />} />}
			/>
			<Route
				path="/:organisation/epos/banking"
				element={<PrivateRoute element={<Banking />} />}
			/>
			<Route
				path="/:organisation/epos/banking-totals"
				element={<PrivateRoute element={<BankingTotals />} />}
			/>
			<Route
				path="/:organisation/epos/cash-declarations"
				element={<PrivateRoute element={<CashDeclarations />} />}
			/>
			<Route
				path="/:organisation/epos/eod-logs"
				element={<PrivateRoute element={<EodLogs />} />}
			/>
			<Route
				path="/:organisation/epos/weekly-targets"
				element={<PrivateRoute element={<WeeklyTargets />} />}
			/>
			<Route
				path="/:organisation/epos/missed-items"
				element={<PrivateRoute element={<MissedItems />} />}
			/>
			<Route
				path="/:organisation/epos/paid-in-out"
				element={<PrivateRoute element={<PaidInOut />} />}
			/>
			<Route
				path="/:organisation/staff/list"
				element={<PrivateRoute element={<StaffList />} />}
			/>
			<Route
				path="/:organisation/staff/attendance"
				element={<PrivateRoute element={<Attendance />} />}
			/>
			<Route
				path="/:organisation/customer/list"
				element={<PrivateRoute element={<Customers />} />}
			/>
			<Route
				path="/:organisation/customer/:id"
				element={<PrivateRoute element={<SingleCustomer />} />}
			/>
			<Route
				path="/:organisation/staff/member/:id"
				element={<PrivateRoute element={<SingleStaffMember />} />}
			/>
			<Route
				path="/:organisation/orders"
				element={<PrivateRoute element={<Orders />} />}
			/>
			<Route
				path="/:organisation/rear-display"
				element={<PrivateRoute element={<RearDisplay />} />}
			/>
			<Route
				path="/:organisation/pharmacy/rx-counts"
				element={<PrivateRoute element={<RxCounts />} />}
			/>
			<Route
				path="/:organisation/pharmacy/near-misses"
				element={<PrivateRoute element={<NearMisses />} />}
			/>
			<Route
				path="/:organisation/pharmacy/prescriptions"
				element={<PrivateRoute element={<Prescriptions />} />}
			/>
			<Route
				path="/:organisation/sales/pharmacy-first"
				element={<PrivateRoute element={<PharmacyFirst />} />}
			/>
			<Route
				path="/error/404"
				element={<PrivateRoute element={<EndpointNotFound />} />}
			/>
			<Route
				path="/error/500"
				element={<PrivateRoute element={<InternalServerError />} />}
			/>
			<Route
				path="/:organisation/accounts"
				element={
					<PrivateRoute
						roles={[BRISTEC_ADMIN, MODERATOR, ADMIN]}
						element={<Accounts />}
					/>
				}
			/>
			<Route
				path="/admin"
				element={
					<AdminRoute roles={[BRISTEC_ADMIN]} element={<BristecAdmin />} />
				}
			/>
			<Route path="*" element={<PageNotFound />} />
		</DomRoutes>
	);
}
